import React from 'react';

import { Table, TableContainer } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { IStaffStatusEvolution } from '../../../../types/staff-status-evolution.type';
import { IFilters } from '../../types';
import StaffStatusEvolutionListBody from '../StaffStatusEvolutionListBody';
import StaffStatusEvolutionListFooter from '../StaffStatusEvolutionListFooter';
import StaffStatusEvolutionListHead from '../StaffStatusEvolutionListHead';

interface IProps {
  filters: IFilters;
  evolution: IStaffStatusEvolution[];
}

const StaffStatusEvolutionList = React.memo(({ evolution, filters }: IProps) => (
  <Grid container mt={3}>
    <Grid item xs={12}>
      <TableContainer component={Paper} sx={{ maxHeight: '80vh' }}>
        <Table stickyHeader aria-label="sticky table">
          <StaffStatusEvolutionListHead filters={filters} />
          <StaffStatusEvolutionListBody evolution={evolution} />
          <StaffStatusEvolutionListFooter evolution={evolution} />
        </Table>
      </TableContainer>
    </Grid>
  </Grid>
));

export default StaffStatusEvolutionList;
